<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-header border-bottom">
      <h5 class="modal-title">{{ "heading-title.fare-estimate" | translate }}</h5>
      <button type="button" class="btn-close" id="close-fare-estmate" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      @if(!isInvoiceModal){
      <p class="mx-2">{{ "label-title.fare-estimate-description" | translate }}</p>
      }
      <table class="table table-borderless text-center table-nowrap align-middle mb-3" aria-describedby="booking-details-table">
        <tbody id="products-list">
          @for (element of arrInvoiceElement; track $index) {
          <tr class="border-bottom border-bottom-dashed">
            <td class="text-start">
              <span class="fw-medium">{{ element.strTitle | translate }}</span>
              @for (item of element.strSubTitleArray; track $index) { @if (item.title) {
              <p class="text-muted mb-0">{{ item.title }}</p>
              } }
            </td>
            <td class="text-end">
              <span class="fw-medium">
                @if(!element.isEditable){
                <span>{{ element.strAmount }}</span>
                } @else {
                <div _ngcontent-ng-c1418812631="" class="input-group">
                  <input type="number" [(ngModel)]="element.price" #price name="price" class="form-control" /><span class="input-group-text">{{ currencySign }}</span>
                </div>
                }
              </span>
              @for (item of element.strSubTitleArray; track $index) { @if (item.value){
              <p class="text-muted mb-0">{{ item.value }}</p>
              } }
            </td>
            @if(isEditFareEstimate && ![helper.PriceParamEnum.surgePrice, helper.PriceParamEnum.minimumFee, helper.PriceParamEnum.promoBonus].includes(element.title)){
            <td class="text-end">
              @if(!element.isEditable){
              <span (click)="element.isEditable = true; isShowUpdatePrice = false" type="button" style="margin-left: 10px" class="edit-list ng-star-inserted">
                <em class="ri-pencil-fill align-bottom"></em></span
              >} @else {
              <span (click)="updatePrice(element)" type="button" style="margin-left: 10px; font-weight: bold; font-size: 16px" class="edit-list ng-star-inserted">
                <em class="ri-check-line align-bottom"></em></span
              >}
            </td>
            }
          </tr>
          } @if (typeDetails?.taxPrices?.length > 0) {
          <tr class="border-top border-top-dashed">
            <td class="text-start">
              <span class="fw-medium">{{ "label-title.total-tax" | translate | titlecase }}</span>
              @for (tax of typeDetails?.taxPrices; track $index) {
              <p class="text-muted mb-0">{{ tax.title }} ({{ tax.unit }}%)</p>
              }
            </td>
            <td class="text-end">
              <span class="fw-medium">
                <span class="d-flex currency-gap justify-content-end">
                  {{ totalTax.toFixed(decimalPointValue) }}
                  <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                    {{ currencySign }}
                  </span>
                </span>
              </span>
              @for (tax of typeDetails?.taxPrices; track $index) {
              <p class="text-muted mb-0">{{ currencySign }} {{ tax.price?.toFixed(decimalPointValue) }}</p>
              }
            </td>
          </tr>
          }@if (isMinfareApplied()) {
          <tr>
            <td>
              <p class="text-danger text-start mb-0">*{{ "label-title.minimum-fare-applied" | translate }}</p>
            </td>
          </tr>
          }
        </tbody>
      </table>
      <table class="w-100">
        <tbody>
          <tr>
            <td class="text-center">
              <p class="text-muted mb-0">
                {{ "label-title.distance" | translate }}
              </p>
              <h5>{{ totalDistance }} {{ this.distanceUnitString | translate }}</h5>
            </td>
            <td class="text-center">
              <p class="text-muted mb-0">
                {{ "label-title.min-fare" | translate }}
              </p>
              <h5>{{ currencySign }} {{ totalPrice }}</h5>
            </td>
            @if(totalTime){
            <td class="text-center">
              <p class="text-muted mb-0">
                {{ "label-title.time" | translate }}
              </p>
              <h5>
                {{ totalTime | titlecase }}
              </h5>
            </td>
            }
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-center">
        <button
          type="button"
          id="view-cancellation-policy-btn"
          class="btn btn-sm btn-outline-secondary mt-3 d-flex align-items-center justify-content-center"
          (click)="onCancellationPolicyModal()"
        >
          {{ "button-title.view-cancellation-policy" | translate | titlecase }}
        </button>
        @if(isShowUpdatePrice){
        <button style="margin-left: 20px" type="button" class="btn btn-primary btn-sm mt-3 d-flex align-items-center justify-content-center" (click)="updateFareEatime()">
          {{ "button-title.update-fare-estimate" | translate | titlecase }}
        </button>
        }
      </div>

      <!-- <div class="d-flex justify-content-end">
                <button id="close-fare-estmate-button"
                    class="btn btn-secondary mt-3 d-flex align-items-center justify-content-center"
                    style="overflow: unset;" (click)="closeModal()"><span class="d-flex align-items-center"><span
                            class="flex-grow-1">{{'button-title.close' | translate |
                            titlecase}}
                        </span></span></button>
            </div> -->
    </div>
  </div>
</ng-template>

<app-cancellation-policy-modal #cancellationPolicyModal></app-cancellation-policy-modal>
